import React from 'react';

const Footer = () => (
    <footer className="container">
        <small className="span-footer">
            © 2020 created by{' '}
            <a href="https://lwolczynski.com" target="_blank" rel="noreferrer">
                lwolczynski
            </a>
        </small>
    </footer>
);

export default Footer;
